export default "__VITE_ASSET__082742f1__"